import { SxProperties } from '@bvi/mui-theme';

export const styles = {
  canvasWrapper: {
    display: 'flex',
    alignItems: 'center',
    // Extra left padding so centered LQ labels ("Lowest Quartile Mean") stay on-canvas
    padding: '0 20px 0 40px',
    overflow: 'visible',
    '& > canvas': {
      width: '100%!important',
      height: '300px!important',
    },
  },
  canvasSkeleton: {
    minHeight: '300px',
    width: '100%',
  },
  stickyWrapper: {
    position: 'sticky',
    top: '270px',
    backgroundColor: 'white',
    borderRadius: '10px',
    zIndex: 5,
  },
} satisfies SxProperties;
